<template>
  <div id="agencyDashboard">
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex md8 xs12 v-if="managementOption !== 'ChildManagement'">  
          <v-card class="pa-2" height="100%">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="title text-xs-left pl-3 mt-3">
                  <v-icon size="22" color="grey darken-2">insert_chart</v-icon>
                  Client Satisfaction
                </div>
              </v-flex>
            </v-layout>
            <e-chart
              ref="ratingChart"
              :path-option="[
                ['dataset.source', ratingData],
                ['color', [color.blue.base, color.indigo.base, color.pink.base, color.green.base, color.cyan.base, color.teal.base]],
                ['legend.show', false],
                ['xAxis.axisLabel.show', true],
                ['xAxis.axisLabel.rotate', 45],
                ['yAxis.axisLabel.show', true],
                ['grid.left', '2%'],
                ['grid.bottom', '5%'],
                ['grid.right', '3%'],
                ['series[0].type', 'bar'],
                ['series[0].areaStyle', {}],
                ['series[0].smooth', true],           
              ]"
              height="400px"
              width="100%"
            ></e-chart>
          </v-card>
        </v-flex>
        <v-flex md4 sm12 xs12 v-if="managementOption !== 'ChildManagement'">
          <v-card class="pa-2" height="100%" style="position: relative;">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="title text-xs-left pl-3 mt-3">
                  Messages <span v-if="getUnreadConversationCount() > 0">({{ getUnreadConversationCount() }}) </span>
                  <v-icon size="22" color="grey darken-2">notifications</v-icon>
                </div>
              </v-flex>
            </v-layout>
            
            <v-toolbar card dense flat class="white chat-room--toolbar" light>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="backToList()" v-on="on">
                    <v-icon color="text--secondary">keyboard_arrow_left</v-icon>
                  </v-btn>
                </template>
                <span>Back to Conversation List</span>
              </v-tooltip>
              <template v-for="(item, index) of conversationItem.human">
                <span :key="index">{{ conversationItem.human.length > index + 1 ? item.display_name + ',' : item.display_name }}</span>
              </template>
              <v-spacer></v-spacer>              
              <v-tooltip top>
                <v-btn icon slot="activator" v-if="conversationItem.last_message" @click="replyMessage(conversationItem.last_message)">
                  <v-icon small color="text--secondary">open_in_new</v-icon>
                </v-btn>
                <span>Open message in a new window</span>
              </v-tooltip>
            </v-toolbar>
            
            <v-divider></v-divider>

            <v-card-text class="conversation_content">
              <div class="loading-overlay" v-if="loadingMessages">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </div>
              <vue-perfect-scrollbar class="messages-conversation">
                <template v-for="(item, index) of conversationItem.message" >
                  <div v-if="item.message.human !== null" v-bind:class="[ session.user().id === item.message.createdBy ? 'reverse' : '']" class="messaging-item layout row" :key="index">
                    <v-avatar class="indigo mx-1" size="36">
                      <template v-if="item.message.human.agency">
                        <img class="white" v-if="(item.message.human.agency.avatar ? item.message.human.agency.avatar : '') !== ''" :src="item.message.human.agency.avatar" alt="">
                        <span v-else class="white--text subheading">
                          {{ session.user().id === item.message.createdBy ? Agency.name.substr(0,2) : item.message.human.agency.name.substr(0,2) }}
                        </span>
                      </template>
                      <template v-else>
                        <img class="white" v-if="(item.message.human.account.avatar ? item.message.human.account.avatar : '') !== ''" :src="[item.message.human.account.avatar ? item.message.human.account.avatar : '']" alt="">
                        <span v-else class="white--text subheading pa-2">
                          {{ session.user().id === item.message.createdBy ? Account.name.substr(0,2) : item.message.human.account.name.substr(0,2) }}
                        </span>
                      </template>
                    </v-avatar>
                    <div>

                      <div class="messaging--body column mx-2">
                        <p class="message">
                          {{ removeHTML(item.message.content) }}
                        </p>
                      </div>
                      <v-container py-0 ma-0 v-if="session.user().id === item.message.createdBy">
                        <v-layout row justify-space-between class="caption mb-2 text--secondary">
                          <v-flex xs4 class="pa-0 ma-0 text-xs-left seen" v-if="item.message.is_seen === true && item.message.createdBy == session.user().id" >
                            <v-icon small color="blue lighten-3">
                              fas fa-circle
                            </v-icon>
                            Seen
                          </v-flex>
                          <v-flex v-else xs4 class="pa-0 ma-0 text-xs-left seen">
                          </v-flex>
                          <v-flex xs8 class="pa-0 ma-0  text-xs-right">
                            {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                          </v-flex>
                        </v-layout>
                      </v-container>

                      <v-container v-else py-0 ma-0>
                        <v-layout row justify-space-between class="caption mb-2 text--secondary">
                          <v-flex xs8 class="pa-0 ma-0 text-xs-left">
                            {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                          </v-flex>
                          <v-flex xs4 class="pa-0 ma-0  text-xs-right">
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                    <v-spacer></v-spacer>
                  </div>
                </template>
              </vue-perfect-scrollbar>

              <v-expand-x-transition mode="in-out">
                <div
                  v-if="conversationList"
                  class="v-card--reveal"
                >
                  <div class="loading-overlay" v-if="loadingMessages">
                    <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                  </div>
                  <vue-perfect-scrollbar class="messages-list">
                    <p class="pt-5 mt-5 title font-weight-light" v-if="!Conversation.length">No messages received</p>
                    <v-list two-line>
                      <template v-for="(item, index) in Conversation">
                        <v-list-tile
                          v-if="(item.groups && item.groups.length) || (item.human && item.human.length > 1)"
                          :key="item.title"
                          avatar
                          :class="(item.last_message && item.last_message.is_seen === false && item.last_message.createdBy !== session.user().id) ? 'unread-row' : 'read-row'"
                        >
                          <v-list-tile-avatar color="teal" v-if="item.last_message && item.last_message.human !== null">
                            <img class="white" v-if="(item.last_message.human.account ? item.last_message.human.account.avatar : Agency.avatar) !== ''" :src="[item.last_message.human.account ? item.last_message.human.account.avatar : Agency.avatar]" alt="">
                            <span v-else class="white--text title">
                              {{ item.last_message.human.account ? item.last_message.human.account.name.substr(0,2) : Agency.name.substr(0,2) }}
                            </span>
                          </v-list-tile-avatar>
                          <v-list-tile-avatar color="teal" v-if="!item.last_message || item.last_message.human === null">
                            <span class="white--text title">
                              {{ item.human[item.human.length -1].display_name.substr(0, 2) }}
                            </span>
                          </v-list-tile-avatar>

                          <v-list-tile-content @click="replyConversation(item)">
                            <v-list-tile-title>
                              <v-tooltip top class="unReadList" v-if="(item.last_message && item.last_message.is_seen === false && item.last_message.createdBy !== session.user().id)" :key="'unreadIcon_' + index">
                                  <v-icon small color="blue lighten-3" slot="activator">
                                    fas fa-circle
                                  </v-icon>
                                <span>Unread message</span>
                              </v-tooltip>
                              <span v-if=" $vuetify.breakpoint.smAndDown">{{item.subject.substr(0, 30) + (item.subject.length > 30 ? '...' : '')}}</span>
                              <span v-if="$vuetify.breakpoint.mdAndUp">{{item.subject.substr(0, 15) + (item.subject.length > 15 ? '...' : '')}}</span>
                              <v-spacer></v-spacer>
                            </v-list-tile-title>
                            <v-list-tile-sub-title v-if="item.last_message && item.last_message.human !== null" class="">{{ item.last_message.human.account ? item.last_message.human.account.name : Agency.name }} - <span class="font-weight-light font-italic">{{ item.last_message && item.last_message.content ? removeHTML(item.last_message.content) : '' }}</span></v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-list-tile-action-text>
                              <v-tooltip top>
                                <v-btn icon flat small class="mb-3" v-if="item.last_message && item.last_message.human !== null" slot="activator" @click="replyMessage(item.last_message)">
                                  <v-icon small color="grey lighten-1">open_in_new</v-icon>
                                </v-btn>
                                <span>Open in a new window</span>
                              </v-tooltip>
                            </v-list-tile-action-text>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider
                          v-if="index + 1 < Conversation.length"
                          :key="index"
                        ></v-divider>
                      </template>
                    </v-list>
                  </vue-perfect-scrollbar>
                  <v-tooltip top v-if="!session.getSession().adminUser">
                    <v-btn slot="activator" @click="messageAddPage" dark fab absolute small bottom left class="pf-bg-green composeMessageBtn">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <span>Create a new Message</span>
                  </v-tooltip>
                </div>
              </v-expand-x-transition>

              <v-fade-transition mode="in-out">
                <div
                  v-if="conversationAddContact"
                  class="v-card--add-contact"
                >
                    <v-container>
                      <v-layout row wrap>
                      <v-flex xs12>
                        <v-autocomplete
                          v-model="selectedAddContact"
                          :items="ContactList"
                          chips
                          label="Select"
                          item-text="name"
                          item-value="human[0].id"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              :selected="data.selected"
                              close
                              class="chip--select-multi"
                              @input="removeContact(data.item)"
                            >
                              <v-avatar>
                                <img :src="data.item.avatar ? data.item.avatar : '/static/profile-pic.jpg'">
                              </v-avatar>
                              {{ data.item.name }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template>
                              <v-list-tile-avatar>
                                <img :src="data.item.avatar ? data.item.avatar : '/static/profile-pic.jpg'">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="data.item.human[0].name"></v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-btn color="success" @click="saveContactList()">close</v-btn>
                </div>
              </v-fade-transition>
            </v-card-text>

            <v-divider v-if="!session.getSession().adminUser"></v-divider>
            <v-card-actions class="pt-0">
              <v-text-field
                v-model="message.content"
                class="input-send-msg"
                full-width
                flat
                clearable
                solo
                dense
                append-icon="send"
                placeholder="Type some message here"
                label=""
                :disabled="conversationItem.length === 0"
                @click:append="send"
                v-if="!session.getSession().adminUser"
              >
              </v-text-field>
            </v-card-actions>  
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-2" height="100%" style="position: relative;">
            <v-layout row wrap v-if="managementOption === 'ChildManagement'">
              <v-flex xs12 class="flex-space-between">
                <div class="title text-xs-left pl-3 mt-3">
                  <v-icon size="22" color="grey darken-2">pie_chart</v-icon>
                  Child Count by Status
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex xs12>
                <div class="title text-xs-left pl-3 mt-3">
                  <v-icon size="22" color="grey darken-2">pie_chart</v-icon>
                  Family Count by Status
                </div>
              </v-flex>
            </v-layout>
            <v-layout row align-center justify-center wrap v-if="managementOption === 'ChildManagement'">
              <v-flex sm3>
                <v-list class="chart-left-menu ml-2">
                  <v-list-tile
                    v-for="(item, i) in childCountByStatus"
                    :key="i"
                    @click="loadActiveChildren(item)"
                    class="pf-bg-teal white--text ma-2 pf-height-35"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title class="pf-font-14">{{ item.label }} {{ '- ('+ item.count +')' }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex sm6>
                <e-chart
                  ref="childCountChart"
                  :path-option="[
                    ['dataset.source', childCountByStatus],
                    ['color', [color.lightBlue.base, color.indigo.base, color.amber.base, color.teal.base, color.deepPurple.base, color.green.base, color.cyan.base, color.pink.base, '#F195BF']],
                    ['legend.orient', 'vertical'],
                    ['legend.y', 'center'],
                    ['legend.x', 'right'],
                    ['xAxis.show', false],
                    ['yAxis.show', false],
                    ['series[0].type', 'pie'],         
                  ]"
                  height="300px"
                  width="100%"
                >
                </e-chart>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center v-else-if="managementOption === 'FamilyManagement'">
              <v-flex sm3>
                <v-list class="chart-left-menu ml-2">
                  <v-list-tile
                    v-for="(item, i) in familyCountByStatus"
                    :key="i"
                    @click="loadActiveFamilies(item)"
                    class="pf-bg-teal white--text ma-2 pf-height-35"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title class="pf-font-14">{{ item.label }} {{ '- ('+ item.count +')' }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex sm9>
                <e-chart
                  ref="familyCountChart"
                  :path-option="[
                    ['dataset.source', familyCountByStatus],
                    ['color', [color.lightBlue.base, color.indigo.base, color.amber.base, color.teal.base, color.deepPurple.base, color.green.base, color.cyan.base, color.pink.base, '#F195BF']],
                    ['legend.orient', 'vertical'],
                    ['legend.y', 'center'],
                    ['legend.x', 'right'],
                    ['xAxis.show', false],
                    ['yAxis.show', false],
                    ['series[0].type', 'pie'],         
                  ]"
                  height="300px"
                  width="100%"
                >
                </e-chart>
              </v-flex>
            </v-layout>

          </v-card>
        </v-flex>
        <v-flex xs12 v-if="isActiveChartEnabled">
          <v-card class="pa-2" height="100%" style="position: relative;">
            <v-flex>
              <div class="title text-xs-left pl-3 mt-3">
                <v-icon size="22" color="grey darken-2">pie_chart</v-icon>
                {{ activeFamilyItem.label }} Family Count - {{ '('+ activeFamilyItem.count + ')' }}
              </div>
            </v-flex>
            <v-flex>
              <e-chart
                ref="activeFamilyCountChart"
                :path-option="[
                  ['dataset.source', activeFamilyCount],
                  ['color', [color.lightBlue.base, color.indigo.base, color.amber.base, color.teal.base, color.deepPurple.base, color.green.base, color.cyan.base, color.pink.base, '#F195BF']],
                  ['legend.orient', 'vertical'],
                  ['legend.y', 'center'],
                  ['legend.x', 'right'],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],         
                ]"
                height="300px"
                width="100%"
              >
              </e-chart>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="isActiveChildChartEnabled">
          <v-card class="pa-2" height="100%" style="position: relative;">
            <v-flex>
              <div class="title text-xs-left pl-3 mt-3">
                <v-icon size="22" color="grey darken-2">pie_chart</v-icon>
                {{ activeChildItem.label }} Child Count - {{ '('+ activeChildItem.count + ')' }}
              </div>
            </v-flex>
            <v-flex>
              <e-chart
                ref="activeChildCountChart"
                :path-option="[
                  ['dataset.source', activeChildrenCount],
                  ['color', [color.lightBlue.base, color.indigo.base, color.amber.base, color.teal.base, color.deepPurple.base, color.green.base, color.cyan.base, color.pink.base, '#F195BF']],
                  ['legend.orient', 'vertical'],
                  ['legend.y', 'center'],
                  ['legend.x', 'right'],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],         
                ]"
                height="300px"
                width="100%"
              >
              </e-chart>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
/* global session store moment config */
import EChart from '@/components/chart/echart';
import Material from 'vuetify/es5/util/colors';
import { getCollection, formatDate, create, update, conversationListPopulate, requestExternal } from '../helpers/helpers';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import store from '../store';

export default {
  components: {
    EChart,
    VuePerfectScrollbar
  },
  data: () => ({
    entity: 'Agency',
    loadingMessages: false,
    color: Material,
    clearAll: false,
    ratingData: [
      {
        label: 'Not Satisfied',
        count: 0
      },
      {
        label: 'Somewhat Satisfied',
        count: 0
      },
      {
        label: 'Satisfied',
        count: 0
      },
      { 
        label: 'Very Satisfied', 
        count: 0
      },
      { 
        label: 'Wow it was Great', 
        count: 0
      }
    ],
    familyCountByStatus: [
      {
        label: 'Active',
        count: 0
      },
      {
        label: 'In Progress',
        count: 0
      },
      { 
        label: 'Pending', 
        count: 0
      },
      { 
        label: 'Approved', 
        count: 0
      },
      { 
        label: 'Inactive', 
        count: 0
      },
      { 
        label: 'Rejected', 
        count: 0
      }
    ],
    childCountByStatus: [
      { 
        label: 'Active', 
        count: 0
      },
      {
        label: 'Family Matched',
        count: 0
      },
      {
        label: 'On Hold',
        count: 0
      }
      
    ],
    activeFamilyCount: [
      {
        label: 'Waiting',
        count: 0
      },
      {
        label: 'Waiting No Avatar',
        count: 0
      },
      {
        label: 'Matched',
        count: 0
      },
      {
        label: 'Matched No Avatar',
        count: 0
      },
      { 
        label: 'Placed', 
        count: 0
      },
      { 
        label: 'Placed No Avatar', 
        count: 0
      }
    ],
    activeChildrenCount: [
      {
        label: 'Active',
        count: 0
      },
      {
        label: 'Active No Avatar',
        count: 0
      },
      {
        label: 'Family Matched',
        count: 0
      },
      {
        label: 'Family Matched No Avatar',
        count: 0
      },
      { 
        label: 'On Hold', 
        count: 0
      },
      { 
        label: 'On Hold No Avatar', 
        count: 0
      }
    ],
    isActiveChartEnabled: false,
    activeFamilyItem: {},
    headers: [
      { text: 'Family Name', value: 'name', align: 'left' },
      { text: 'PPN', value: 'ppn' },
      { text: 'Status', value: 'status', width: '150px' },
      { text: 'Join Date', value: 'agency.createdAt' }
    ],
    conversationList: true,
    conversationAddContact: false,
    conversationId: '',
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    conversationItem: {
      message: [],
      account: ''
    },
    conversationIndex: -1,
    selectedAddContact: [],
    pagination: {
      sortBy: ''
    },
    activeChildItem: {},
    isActiveChildChartEnabled: false,
    managementOption: 'FamilyManagement'
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency', 'Faq', 'MyFamilies']),

    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    ConversationLoaded: {
      get () {
        return store.state.ConversationLoaded;
      },
      set (value) {
        store.commit('setConversationLoaded', value);
      }
    },
    Message: {
      get () {
        return store.state.Message;
      },
      set (value) {
        store.commit('setMessage', value);
      }
    },
    MessageLoaded: {
      get () {
        return store.state.MessageLoaded;
      },
      set (value) {
        store.commit('setMessageLoaded', value);
      }
    },
    ContactList: {
      get () {
        return store.state.ContactList;
      },
      set (value) {
        store.commit('setContactList', value);
      }
    },
    FaqLoaded: {
      get () {
        return store.state.FaqLoaded;
      },
      set (value) {
        store.commit('setFaqLoaded', value);
      }
    },
    ChildGroup: {
      get () {
        return store.state.ChildGroup;
      },
      set (value) {
        store.commit('setChildGroup', value);
      }
    }
  },
  watch: {
    Conversation (value) {
      this.Conversation = value;
      if (this.conversationIndex > -1) {
        this.conversationItem = this.Conversation.find(item => item.id === this.conversationId);
        this.conversationIndex = this.Conversation.indexOf(this.conversationItem);
        // Read the new messages
        this.updateReadStatus();
      }
    }
  },
  async created () {
    this.managementOption = this.Agency.feature_settings && this.Agency.feature_settings.length ? this.Agency.feature_settings[0] : 'FamilyManagement';
    if (this.managementOption === 'FamilyManagement') {
      this.initializeConversation();
      this.initializeFaqs();
      this.getRating();
      await this.setFamilyCountByStatus();
    } else if (this.managementOption === 'ChildManagement') {
      await this.initializeChildGroup();
      await this.setChildCountByStatus();
    }
   
  },
  methods: {
    messageAddPage () {
      this.$router.push({ name: 'addMessage', query: { preUrl: `/agency/dashboard` }});
    },
    removeHTML (text) {
      let strippedText = text.replace(/(<([^>]+)>)/ig, '');
      strippedText = strippedText.substr(0, 100);
      return strippedText;
    },
    backToList () {
      this.conversationList = !this.conversationList;
      this.conversationIndex = -1;
    },
    async initializeConversation () {
      if (!this.Conversation.length && !this.ConversationLoaded) {
        this.conversationItem = {};
        this.loadingMessages = true;
        let sessionUser = session.getSession();
        let entity = 'Conversation';
        let sort = { 'updatedAt': -1 };
        let where = {};
        where = {
          $and: [
            {
              $or: [
                {
                  human: sessionUser.user.human.id
                }
              ]
            },
            {
              $or: [
                {
                  archive: { $exists: false }
                },
                {
                  archive: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            },
            {
              $or: [
                {
                  removed: { $exists: false }
                },
                {
                  removed: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            }
          ]
        };
        if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
          where.$and[0].$or.push({
            groups: {
              $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
            }
          });
        }
        let { error, data } = await getCollection('Conversation', true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          this.ConversationLoaded = true;
          if (data.length > 0) {
            this.Conversation = data;
            // this.conversationItem = this.Conversation[0];
            // this.conversationId = this.conversationItem.id;
            // this.conversationIndex = this.Conversation.indexOf(this.conversationItem);
            // this.conversationItem.human.forEach(element => {
            //   this.selectedAddContact.push(element.id);
            // });
            setTimeout(() => {
              const container = this.$el.querySelector('.ps-container.messages-conversation');
              container.scrollTop = container.scrollHeight;
              this.loadingMessages = false;
            }, 0);
            
          } else {
            this.loadingMessages = false;
          }
        }
      }
    },
    async replyConversation (conversation) {
      this.conversationId = conversation.id;
      this.conversationItem = conversation;
      this.conversationIndex = this.Conversation.indexOf(conversation);
      
      this.conversationList = false;
      await this.updateReadStatus();
    },
    async initializeMessages () {
      if (!this.Message.length && !this.MessageLoaded) {
        this.loadingMessages = true;
        let entity = 'Message';
        let { error, data } = await getCollection(entity);
        if (error) {
          console.log(error);
        } else {
          this.MessageLoaded = true;
          if (data.length > 0) {
            this.Message = data;
          }
          this.loadingMessages = false;
        }
      }
    }, 
    async initializeFaqs () {
      if (!this.Faq.length && !this.FaqLoaded) {
        let entity = 'Faq';
        let { error, data } = await getCollection(entity);
        if (error) {
          console.log(error);
        } else {
          this.FaqLoaded = true;
          if (data.length > 0) {
            store.commit('setFaq', data);
          }
        }
      }
    },
    async initializeChildGroup () {
      if (!this.ChildGroup.length) {
        let entity = 'ChildGroup';
        let where = { agency: this.Agency._id };
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setChildGroup', data);
          }
        }
      }
    },
    replyMessage (item) {
      this.$router.push({ path: '/message/reply/' + item.conversation, query: { preUrl: 'dashboard' }});
    },            
    formatDate (dateString) {
      if (dateString) {
        return moment(dateString).format('MM/DD/YYYY');
      }
    },
    /* eslint max-depth: [2, 6] */
    getUnreadConversationCount () {
      let conversationList = this.Conversation;
      let unReadCount = 0;
      if (conversationList) {
        for (let i = 0; i < conversationList.length; i++) {
          let messageList = conversationList[i].message;
          let unReadMessageCount = 0;
          if (messageList) {
            for (let j = 0; j < messageList.length; j++) {
              if (messageList[j]) {
                if (messageList[j].message && messageList[j].message.createdBy !== session.user().id && messageList[j].message.is_seen === false) {
                  unReadMessageCount++;
                }
              }
            }
          }
          if (unReadMessageCount > 0) {
            unReadCount++;
          }
        }        
      }
      return unReadCount;
    },
    getRating () {
      if (this.Agency && this.Agency.rating) {
        if (this.Agency.rating.r1 >= 0) {
          this.ratingData[0].count = this.Agency.rating.r1;
        }
        if (this.Agency.rating.r2 >= 0) {
          this.ratingData[1].count = this.Agency.rating.r2;
        }
        if (this.Agency.rating.r3 >= 0) {
          this.ratingData[2].count = this.Agency.rating.r3;
        }
        if (this.Agency.rating.r4 >= 0) {
          this.ratingData[3].count = this.Agency.rating.r4;
        }
        if (this.Agency.rating.r5 >= 0) {
          this.ratingData[4].count = this.Agency.rating.r5;
        }
      }
      if (this.$refs.ratingChart) {
        this.$refs.ratingChart.init(); 
      }
    },
    async setFamilyCountByStatus () {

      if (this.Agency.account && this.Agency.account.length) {
        let inProgressFamilies = this.Agency.account.filter(x => x.status === 'In Progress');
        if (inProgressFamilies.length) {
          this.familyCountByStatus[1].count = inProgressFamilies.length;
        }
        let pendingFamilies = this.Agency.account.filter(x => x.status === 'Pending');
        if (pendingFamilies.length) {
          this.familyCountByStatus[2].count = pendingFamilies.length;
        }
        let approvedFamilies = this.Agency.account.filter(x => x.status === 'Approved');
        if (approvedFamilies.length) {
          this.familyCountByStatus[3].count = approvedFamilies.length;
        }
        let inactiveFamilies = this.Agency.account.filter(x => x.status === 'Inactive');
        if (inactiveFamilies.length) {
          this.familyCountByStatus[4].count = inactiveFamilies.length;
        }
        let rejectedFamilies = this.Agency.account.filter(x => x.status === 'Rejected');
        if (rejectedFamilies.length) {
          this.familyCountByStatus[5].count = rejectedFamilies.length;
        }
        let activeFamilies = this.Agency.account.filter(x => x.status === 'Active');
        if (activeFamilies.length) {
          this.familyCountByStatus[0].count = activeFamilies.length;
        }

      }
      if (this.$refs.familyCountChart) {
        this.$refs.familyCountChart.init();
      }
      
    },
    async setChildCountByStatus () {
      if (this.ChildGroup && this.ChildGroup.length) {
        let familyMatchedChildren = this.ChildGroup.filter(x => x.status.status === 'Family Matched');
        if (familyMatchedChildren && familyMatchedChildren.length) {
          this.childCountByStatus[1].count = familyMatchedChildren.length;
        }
        let onHoldChildren = this.ChildGroup.filter(x => x.status.status === 'On Hold');
        if (onHoldChildren && onHoldChildren.length) {
          this.childCountByStatus[2].count = onHoldChildren.length;
        }
        let activeChildren = this.ChildGroup.filter(x => x.status.status === 'Active');
        if (activeChildren && activeChildren.length) {
          this.childCountByStatus[0].count = activeChildren.length;
        }
      }
      if (this.$refs.childCountChart) {
        this.$refs.childCountChart.init();
      }
      
    },
    async setActiveFamiliesCount (status) {

      let sourceList = [];
      if (status) {
        /* Setup the source family list */
        let accountIds = this.Agency.account && this.Agency.account.length ? this.Agency.account.filter(x => x.account && x.status && x.status === status).map(x => x.account) : [];
        let where = { '_id': { '$in': accountIds }};
        let attributes = 'avatar,placement_status';
        let { error, data } = await getCollection('Account', false, 10000, '', where, attributes);
        
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the family count.'
          };
          return;

        } else {
          sourceList = data;
        }
      
        let waitingFamilies = sourceList.filter(x => x.placement_status && x.placement_status.status === 'Waiting' && (x.avatar || x.avatar !== ''));
        this.activeFamilyCount[0].count = waitingFamilies.length;
        let waitingFamiliesWA = sourceList.filter(x => x.placement_status && x.placement_status.status === 'Waiting' && (!x.avatar || x.avatar === ''));
        this.activeFamilyCount[1].count = waitingFamiliesWA.length;
        
        let matchedFamilies = sourceList.filter(x => x.placement_status && x.placement_status.status === 'Matched' && (x.avatar || x.avatar !== ''));
        this.activeFamilyCount[2].count = matchedFamilies.length;
        let matchedFamiliesWA = sourceList.filter(x => x.placement_status && x.placement_status.status === 'Matched' && (!x.avatar || x.avatar === ''));
        this.activeFamilyCount[3].count = matchedFamiliesWA.length;
        
        let placedFamilies = sourceList.filter(x => x.placement_status && x.placement_status.status === 'Placed' && (x.avatar || x.avatar !== ''));
        this.activeFamilyCount[4].count = placedFamilies.length;
        let placedFamiliesWA = sourceList.filter(x => x.placement_status && x.placement_status.status === 'Placed' && (!x.avatar || x.avatar === ''));
        this.activeFamilyCount[5].count = placedFamiliesWA.length;
        
        /* let noAvatarFamilies = sourceList.filter(x => !x.avatar || x.avatar === '');
        this.activeFamilyCount[3].count = noAvatarFamilies.length; */
        
        /* Reset the chart */
        if (this.$refs.activeFamilyCountChart) {
          this.$refs.activeFamilyCountChart.init();
        }
      }


    },  
    async setActiveChildrenCount (status) {

      if (status) {
        /* Setup the source child list */
        let sourceList = this.ChildGroup && this.ChildGroup.length ? this.ChildGroup.filter(x => x.status.status && x.status.status === status).map(x => x) : [];
       
        let activeChildren = sourceList && sourceList.filter(x => x.status && x.status.status === 'Active' && (x.avatar || x.avatar !== ''));
        this.activeChildrenCount[0].count = activeChildren.length;
        let activeChildrenWA = sourceList && sourceList.filter(x => x.status && x.status.status === 'Active' && (!x.avatar || x.avatar === ''));
        this.activeChildrenCount[1].count = activeChildrenWA.length;
        let familyMatchedChildren = sourceList && sourceList.filter(x => x.status && x.status.status === 'Family Matched' && (x.avatar || x.avatar !== ''));
        this.activeChildrenCount[2].count = familyMatchedChildren.length;
        let familyMatchedChildrenWA = sourceList && sourceList.filter(x => x.status && x.status.status === 'Family Matched' && (!x.avatar || x.avatar === ''));
        this.activeChildrenCount[3].count = familyMatchedChildrenWA.length;
        
        let onHoldChildren = sourceList && sourceList.filter(x => x.status && x.status.status === 'On Hold' && (x.avatar || x.avatar !== ''));
        this.activeChildrenCount[4].count = onHoldChildren.length;
        let onHoldChildrenWA = sourceList && sourceList.filter(x => x.status && x.status.status === 'On Hold' && (!x.avatar || x.avatar === ''));
        this.activeChildrenCount[5].count = onHoldChildrenWA.length;
        
        
        /* Reset the chart */
        if (this.$refs.activeChildCountChart) {
          this.$refs.activeChildCountChart.init();
        }

      }
    },   
    async loadActiveFamilies (item) {
      /* Setup the active count based on the selected status */
      await this.setActiveFamiliesCount(item.label);
      this.activeFamilyItem = item;
      this.isActiveChartEnabled = true;
    },
    async loadActiveChildren (item) {
      /* Setup the active count based on the selected status */
      await this.setActiveChildrenCount(item.label);
      this.activeChildItem = item;
      this.isActiveChildChartEnabled = true;
    },
    async send () {
      if (this.message.content) {
        this.selectedData = false;
        this.message.conversation = this.conversationId;
        this.message.sender = this.Agency.human[0];
        let { error, data, status } = await create('Message', this.message);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          let messageData = {};
          let humanData = {
            agency: {
              avatar: this.Agency.avatar,
              id: this.Agency.id,
              name: this.Agency.name,
              _id: this.Agency._id
            },
            birth_date: this.Agency.human[0].birth_date,
            id: this.Agency.human[0].id,
            user: this.Agency.human[0].user,
            _id: this.Agency.human[0]._id
          };
          data.human = humanData;
          messageData.message = data;
          this.Conversation[this.conversationIndex].message.push(messageData);
          this.Conversation[this.conversationIndex].last_message = data;
          
          swal.fire({
            type: 'success',
            title: 'Message sent successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.message.content = '';
              // this.$router.push({ path: '/messages' });
            }
          });

          setTimeout(() => {
            const container = this.$el.querySelector('.ps-container.messages-conversation');
            container.scrollTop = container.scrollHeight;
          }, 0);
        }
      }
    },
    async updateReadStatus () {
      // Update if logged in user is the recipient
      if (!session.getSession().adminUser) {
        this.conversationItem.message.forEach(async (element, index) => {
          if (element.message && element.message.human && element.message.createdBy !== session.user().id && element.message.is_seen === false) {
            element.message.is_seen = true;
            let updateData = JSON.parse(JSON.stringify(element.message));
            updateData.human = updateData.human.id;
            let { error, data, status } = await update('Message', updateData, updateData.id);
            if (error) {
              console.log('error', error);
            } else {
              this.conversationItem.message[index].message.is_seen = true;
              // console.log('updateReadStatus', data);
            }
          }   
        });
        if (this.conversationItem.last_message) {
          this.conversationItem.last_message.is_seen = true;
        }
      }
    }
  }
};
</script>
<style scoped>
.message-list{
  cursor: pointer;
  margin-top: 1px;
  margin-bottom: 1px;
}
.messages-content, .help-content {
  height: 355px;
}
.v-list__tile__action.sortHandle{
  display: contents !important;
}
.v-list__tile__action{
  position: absolute;
  right: 15px;
}
.v-card__title.sortHandle{
  cursor: move;
}
.v-card__text {
  max-height: 380px;
  height: 375px;
  text-align: center;
  position: relative;
}
.input-send-msg >>> .v-input__slot {
  min-height: 30px !important;
}
.v-card__actions{
  display: block !important;
  text-align: center;
  height: 52px;
}
 /* messaage section styles */
 .loading-overlay {
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
}
.composeMessageBtn {
  position: absolute;
  top: auto;
  bottom: -25px;
  left: auto;
  right: -5px;
}
.fontWeight-300 {
  font-weight: 300;
}
.message-list {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 1px;
  margin-top: 1px;
}
.messaging--body {
  padding: 10px 0px;
  margin-top: 2px !important;
  border-radius: .25rem;
  margin: 15px 5px;
  background-color: #fff;
  transition: all .3s cubic-bezier(.23,1,.32,1);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  position: relative;
  width: 95%;
}
.messaging--title {
  padding: 0px 0px 5px 15px;
  text-align: start;
}
.messaging--title .messageRead{
  float: right;
  margin-right: 10px;
}
.messaging--title .human {
  font-size: 14px;
  font-weight: bold;
}
.messaging--title .time {
  font-size: 12px;
}
.messaging-item {
  margin: 0px !important;
}
.messaging-item .v-avatar {
  margin-left: 10px !important;
}
.reverse .v-avatar {
  margin-right: 10px !important;
  margin-left: 14px !important;
}
.messaging--body .message {
  padding: 5px auto;
  margin: 15px;
  text-align: justify;
}
.conversation_content {
  max-height: 360px;
  padding: 5px
}
.messages-conversation {
  height: 340px;
}
.message-list {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 1px;
  margin-top: 1px;
}
.messaging--body {
  padding: 10px 0px;
  margin-top: 2px !important;
  border-radius: 0rem 1.25rem 1.25rem 1.25rem;
  margin: 15px 5px;
  background-color: #64B5F6;
  color: #fff;
  transition: all .3s cubic-bezier(.23,1,.32,1);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  position: relative;
  min-width: 150px;
}
.reverse .messaging--body {
  border-radius: 1.25rem 0rem 1.25rem 1.25rem;
  background-color: #ECECEC;
  color: #333;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
}
.messaging--title {
  padding: 0px 0px 5px 15px;
  text-align: start;
  overflow: auto;
}
.messaging--title .messageRead{
  float: right;
  margin-right: 10px;
}
.messaging--title .human {
  font-size: 14px;
  font-weight: bold;
}
.messaging--title .time {
  font-size: 12px;
  display: inline-block;
}
.messaging--body .message {
  margin: 0px 15px;
  text-align: left;
}
.seen .v-icon{
  font-size: 6px !important;
  vertical-align: middle;
}
.seen {
  color: #64B5F6;
}
.unReadList {
  /* position: absolute;
  right: 0px;
  padding: 15px 10px; */
  vertical-align: text-bottom;
}
.unReadList .v-icon{
  font-size: 10px !important;
 }
 .unread-row .v-list__tile__title, .unread-row .v-list__tile__sub-title {
  font-weight: 800 !important;
 }
 .v-card--reveal, .v-card--add-contact {
  z-index: 1;
  top: -51px;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: max-content;
}
.avatar-chat {
  margin-left: -10px;
  -webkit-box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}
.chat-room--toolbar {
  min-height: 48px !important;
}
.chat-room--toolbar .v-toolbar__title{
  font-size: 16px;
  font-weight: 400;
  white-space: normal;
  text-align: center;
}

.messages-list {
  height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AgencyDashboard.vue